export type SvgName =
  | "alert-circle"
  | "circle-arrow-down"
  | "circle-arrow-up"
  | "medal-bronze"
  | "medal-gold"
  | "medal-silver"
  | "money-bag"
  | "shield"
  | "stop"
  | "chance"
  | "laurel"
  | "double-chance"
  | "close"
  | "replay"
  | "minus"
  | "plus"
  | "eraser"
  | "logo"
  | "menu"
  | "arrow-left"
  | "arrow-right";
